"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
require("./favorites-dialog-sk");
